import { createSelector } from 'reselect';
import { sortObjectListByKey } from 'utils/arrayHelpers';

/*------------------------------------------------------------------------------------------------*/
/* Collection Builder Selectors                                                                   */
/*------------------------------------------------------------------------------------------------*/
/**
 * collectionBuilderSelector
 * Selector for the catalog collection builder state.
 * @param { Object } state: The application state.
 * @returns { Object } The catalog collection builder state.
 */
export const collectionBuilderSelector = (state) => state.catalogs.collectionBuilder;

export const createCollectionBuilderSelector = (attr) =>
  createSelector(collectionBuilderSelector, (collectionBuilder) => collectionBuilder[attr]);

/**
 * Selectors for the catalog collection builder state.
 * @param { Object } state: The application state.
 * @returns { Any } The value of the determined catalog collection builder state.
 */
export const selectCatalog = createCollectionBuilderSelector('catalog');
export const selectCollectionHasChanged = createCollectionBuilderSelector('collectionHasChanged');
export const selectCollectionNotFound = createCollectionBuilderSelector('collectionNotFound');
export const selectCurrentFields = createCollectionBuilderSelector('currentFields');
export const selectDescription = createCollectionBuilderSelector('description');
export const selectDidPreviewData = createCollectionBuilderSelector('didPreviewData');
export const selectError = createCollectionBuilderSelector('error');
export const selectId = createCollectionBuilderSelector('id');
export const selectIsFetchingCatalogs = createCollectionBuilderSelector('isFetchingCatalogs');
export const selectIsFetchingCollection = createCollectionBuilderSelector('isFetchingCollection');
export const selectIsLoadingPreview = createCollectionBuilderSelector('isLoadingPreview');
export const selectIsSaving = createCollectionBuilderSelector('isSaving');
export const selectName = createCollectionBuilderSelector('name');
export const selectPreviewData = createCollectionBuilderSelector('previewData');
export const selectFieldMappings = createCollectionBuilderSelector('fieldMappings', []);

export const selectFieldMappingsByType = createSelector([selectFieldMappings], (mappings) => {
  const sortedMappings = sortObjectListByKey(mappings ?? [], 'name');

  const fieldMappings = sortedMappings.reduce(
    (fieldBuilder, { name, type }) => ({
      ...fieldBuilder,
      [type]: !fieldBuilder[type]
        ? [{ text: name, value: name }]
        : [...fieldBuilder[type], { text: name, value: name }],
    }),
    {},
  );

  return fieldMappings;
});
